import { handleActions, combineActions } from "redux-actions";
import * as Immutable from "immutable";

import * as Actions from "../index";
import {userLogoutReceived} from "../../../security";

export const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  isFetchingData: false,
  error: "",
  contacts: [],
});

const contactsReducer = handleActions(
  {
    [combineActions(Actions.fetchContactRequested, Actions.createContactRequested,
      Actions.fetchAllContactsRequested, Actions.updateContactRequested, Actions.fetchAccountContactsRequested)](state, action) {
      return state
        .set("isFetchingData", true)
        .set("error", "");

    },
    [combineActions(Actions.fetchContactFailed, Actions.createContactFailed,
      Actions.fetchAllContactsFailed, Actions.updateContactFailed, Actions.fetchAccountContactsFailed)](state, action) {
      return state
        .set("isFetchingData", false)
        .set("error", action.payload)
    },
    [combineActions(Actions.fetchContactReceived)](state, action) {
      let updatedState = state.set("isFetchingData", false)
      if(action.payload) {
        updatedState = updatedState.update("contacts", contacts => {
          const index = contacts.findIndex(contact => contact.get("contactId") === action.payload.contactId)
          if(index >= 0) {
            return contacts.set(index, Immutable.fromJS(action.payload))
          } else {
            return contacts.push(Immutable.fromJS(action.payload))
          }
        })
      }
      return updatedState;
    },
    [combineActions(Actions.fetchAllContactsReceived, Actions.fetchAccountContactsReceived)](state, action) {
      return state
        .set("isFetchingData",false)
        .set("contacts",Immutable.fromJS(action.payload))
    },
    [combineActions(Actions.createContactReceived, Actions.updateContactReceived)](state, action) {
      return state
        .set("isFetchingData",false)
    },
    [userLogoutReceived](state, action) {
      return initialState
    },
  },
  initialState
);

export { contactsReducer };


// WEBPACK FOOTER //
// ./src/features/contact/store/contactsReducer.js